define('viewmodels/modals/dialogs/TermsDialog',[],function () {

    function TermsDialog(dialog, page, vocabulary, isNew) {
        this.dialog = dialog;
        this.title = vocabulary.translate(isNew ? 'MODAL_TEXT_NEW_TAC_VERSION' : 'LABEL_TERMS_AND_CONDITIONS');
        this.content = page.content;
        this.showAgreeButton = isNew;
        this.agreeToTermsButtonText = vocabulary.translate('BUTTON_AGREE_TO_TERMS');
    }

    TermsDialog.prototype.show = function() {
        return this.dialog.showDialog(this);
    };

    TermsDialog.prototype.close = function() {
        this.dialog.close(this);
    };

    return TermsDialog;
});

